// Điền sẵn thông tin sinh khi mở /tu-vi hoặc /bat-tu từ trang khác (vd trang Đoán
// giờ sinh): `?ho_ten=&ngay=YYYY-MM-DD&gio=HH:MM&gioi_tinh=nam|nu`. Ngày LUÔN là
// dương lịch — nơi gọi tự đổi âm → dương trước (BE đoán giờ trả sẵn ngày dương).

export type ChartPrefillSearch = {
  ho_ten?: string;
  ngay?: string;
  gio?: string;
  gioi_tinh?: string;
};

export type ChartPrefill = {
  name: string;
  year: number;
  month: number;
  day: number;
  time: string; // HH:MM
  gender: "nam" | "nu";
};

function str(v: unknown): string | undefined {
  return typeof v === "string" && v ? v : undefined;
}

/** Dùng trong `validateSearch` — chỉ giữ chuỗi, soát kỹ ở `parseChartPrefill`. */
export function chartPrefillSearch(search: Record<string, unknown>): ChartPrefillSearch {
  return {
    ho_ten: str(search.ho_ten),
    ngay: str(search.ngay),
    gio: str(search.gio),
    gioi_tinh: str(search.gioi_tinh),
  };
}

/** Đủ ngày + giờ hợp lệ thì trả prefill, thiếu hay sai một trường là bỏ cả (không điền nửa vời). */
export function parseChartPrefill(search: ChartPrefillSearch): ChartPrefill | null {
  const date = /^(\d{4})-(\d{2})-(\d{2})$/.exec(search.ngay ?? "");
  const time = /^(\d{2}):(\d{2})$/.exec(search.gio ?? "");
  if (!date || !time) return null;
  const [year, month, day] = [Number(date[1]), Number(date[2]), Number(date[3])];
  const [hh, mm] = [Number(time[1]), Number(time[2])];
  const probe = new Date(year, month - 1, day);
  const validDate =
    probe.getFullYear() === year && probe.getMonth() === month - 1 && probe.getDate() === day;
  if (!validDate || hh > 23 || mm > 59) return null;
  return {
    name: (search.ho_ten ?? "").trim().slice(0, 120),
    year,
    month,
    day,
    time: `${time[1]}:${time[2]}`,
    gender: search.gioi_tinh === "nu" ? "nu" : "nam",
  };
}

export function buildChartPrefillSearch(p: ChartPrefill): Required<ChartPrefillSearch> {
  const pad = (n: number) => String(n).padStart(2, "0");
  return {
    ho_ten: p.name,
    ngay: `${p.year}-${pad(p.month)}-${pad(p.day)}`,
    gio: p.time,
    gioi_tinh: p.gender,
  };
}
